import React from "react"
import PropTypes from "prop-types"

import { ProfileHeader } from "./profile_header"
import { patch } from "shared/lib/api"
import { rejectedXHRPromiseLogger } from "shared/lib/xhr_promise"
import iconChecked from "images/icons/icon-checked.svg"
import iconUnchecked from "images/icons/icon-unchecked.svg"

import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

export default class ProfileProviderView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      initialProvider: this.props.profile.profile_provider,
      selectedProvider: this.props.profile.profile_provider,
      canSubmit: false,
    }
  }

  updateSelectedProvider = provider => {
    this.setState({
      selectedProvider: provider,
    })

    if (
      this.state.initialProvider &&
      this.state.initialProvider.module_name === provider.module_name
    ) {
      this.state.canSubmit && this.setState({ canSubmit: false })
      return
    }

    logIFTTTNextAction("click", {
      object_type: "service",
      object_id: provider.module_name,
      location_type: "profile_edit",
      source_location_type: this.props.source,
    })

    this.setState({
      canSubmit: true,
    })
  }

  submitProvider = () => {
    logIFTTTNextAction("click", {
      object_type: "service_authentication",
      object_id: this.state.selectedProvider.module_name,
      location_type: "profile_edit",
      source_location_type: this.props.source,
    })

    patch(this.props.updateProviderPath, {
      provider: this.state.selectedProvider.module_name,
    }).catch(rejectedXHRPromiseLogger())
  }

  renderCheckboxItem = provider => {
    const checked =
      this.state.selectedProvider &&
      this.state.selectedProvider.name === provider.name

    return (
      <li
        key={provider.name}
        onClick={() => this.updateSelectedProvider(provider)}
        className={checked ? "checked" : "unchecked"}
      >
        <span>{provider.name}</span>
        <span
          className="checked-svg"
          dangerouslySetInnerHTML={
            checked ? { __html: iconChecked } : { __html: iconUnchecked }
          }
        />
      </li>
    )
  }

  render() {
    return (
      <div className="provider-view">
        <ProfileHeader avatar={this.props.avatar} headerText="Choose profile">
          <span className="profile-label">
            Using
            <div className="provider-name">
              {this.props.profile.profile_provider
                ? this.props.profile.profile_provider.name
                : "None"}
            </div>
          </span>
        </ProfileHeader>
        <ul>
          {this.props.profileProviders.map((provider, idx) => {
            return this.renderCheckboxItem(provider)
          })}
        </ul>
        <div className="set-profile-actions">
          <button
            className="button-primary"
            onClick={this.submitProvider}
            disabled={!this.state.canSubmit}
          >
            Set profile
          </button>
        </div>
      </div>
    )
  }
}

ProfileProviderView.propTypes = {
  avatar: PropTypes.string,
  profile: PropTypes.object,
  profileProviders: PropTypes.array,
  updateProviderPath: PropTypes.string,
  backButtonPath: PropTypes.string.required,
  email: PropTypes.string,
  source: PropTypes.string,
}
